module.exports = __webpack_public_path__ + "static/img/Josh-Kelly.daa1375.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh-Kelly.jpg
// module id = 5xbL
// module chunks = 0